// Import necessary dependencies and utilities
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create client API using createApi function from Redux Toolkit
const purchaseOrdersAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'purchaseOrdersAPI',
    endpoints: (builder) => ({

        getSuppliersListForDropdown: builder.query({
            query: (data) => ({
                url: `Inventory/GetSuppliersListForDropdown?plSupplierRoleKey=${data.plSupplierRoleKey}&pbIncludeInactive=${data.pbIncludeInactive}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllPurchaseOrders: builder.query({
            query: (data) => ({
                url: `Inventory/GetAllPO?plSupplierKey=${data.plSupplierKey}&pbIncludeClosed=${data.pbIncludeClosed}&pdtStartDate=${data.pdtStartDate}&pdtEndDate=${data.pdtEndDate}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getPoDetailsById: builder.query({
            query: (data) => ({
                url: `Inventory/GetPODetailsById?plSupplierPOKey=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAvailableInventoryForPurhcaseOrder: builder.mutation({
            query: (data) => ({
                url: `/Inventory/GetInventoryAvailableForSupplierPOList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateUnitCost: builder.mutation({
            query: (data) => ({
                url: `/Inventory/UpdateUnitCostInventoryAndSupplierSize`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSupplierPOTrans: builder.query({
            query: (data) => ({
                url: `/Inventory/GetSupplierPOTrans?plSupplierPOKey=${data}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addSupplierPOTran: builder.mutation({
            query: (data) => ({
                url: `/Inventory/AddSupplierPOTran`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updatePOTranDetails: builder.mutation({
            query: (data) => ({
                url: `/Inventory/UpdatePOTranDetails`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        supplierPOTranDelete: builder.mutation({
            query: (data) => ({
                url: `/Inventory/SupplierPOTranDelete?plSupplierPOTranKey=${data.plSupplierPOTranKey}`,
                method: 'POST',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateSupplierPO: builder.mutation({
            query: (data) => ({
                url: `/Inventory/UpdateSupplierPO`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        DeletePurchaseOrder: builder.mutation({
            query: (plSupplierPOKey) => ({
                url: `/Inventory/DeletePO?plSupplierPOKey=${plSupplierPOKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useLazyGetSuppliersListForDropdownQuery,
    useLazyGetAllPurchaseOrdersQuery,
    useLazyGetPoDetailsByIdQuery,
    useGetAvailableInventoryForPurhcaseOrderMutation,
    useUpdateUnitCostMutation,
    useLazyGetSupplierPOTransQuery,
    useAddSupplierPOTranMutation,
    useUpdatePOTranDetailsMutation,
    useSupplierPOTranDeleteMutation,
    useUpdateSupplierPOMutation,
    useDeletePurchaseOrderMutation
} = purchaseOrdersAPI;

export default purchaseOrdersAPI;
